import template from './createCustomerModal.html';
import controller from './createCustomerModal.controller';

let CreateCustomerModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

export default CreateCustomerModalComponent;




// WEBPACK FOOTER //
// ./client/pages/admin/customers/modals/createCustomerModal/createCustomerModal.component.js